/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/*
 * Using this json only for 18F brand.
 */
const data = {
    page_title: 'Frequently Asked Questions About Funeral Flowers & Sympathy Gifts',
    description_top: 'Helping someone to deal with the loss of a loved one is never easy. Here are some helpful ways to express your sympathy and lend your support during difficult times.',
    description_bottom: 'Some cemeteries have rules about leaving flowers at the grave, which may restrict your options. For example, some prefer not to allow artificial flowers, while others may put a ban on leaving anything on gravesites in certain areas. Still others allow you to place live or potted flowers at the site, with the understanding that you will be responsible for the upkeep and disposal of the plant.',
    content: [
        {
            question: 'Can I send food or fruit baskets to the funeral home for the family?',
            answer: 'It is always best to contact the funeral home first to find out if such deliveries are accepted. If not, it’s best to send sympathy food gifts to the home of the bereaved.',
        },
        {
            question: 'What should I write in a condolence letter?',
            answer: 'A condolence letter is a personal expression of sympathy and support to one or more members of the grieving family. If you have a cherished memory of the deceased, it is appropriate to share that memory in your letter. Otherwise, general kind words and sentiments are appropriate.',
        },
        {
            question: 'What is appropriate to send for cremations?',
            answer: '<a class="jss103" href="/sympathy/cremation-11835">Cremation</a> is becoming an acceptable alternative for many religions that had previously preferred burial only. Many cremations involve a standard funeral service in a chapel or church, and flowers are appropriate at these services. Standing sprays, baskets and even elegant vase arrangements are suitable.',
        },
        {
            question: 'Can I send sympathy flowers if there is no funeral service?',
            answer: 'Yes. It is appropriate to send floral arrangements to a memorial.',
        },
        {
            question: 'What does "in lieu of flowers" mean?',
            answer: 'The phrase "in lieu of flowers" is often used to encourage charitable gifts—but not necessarily to suggest that no flowers be given or sent. Indeed, a family might regret having too few flowers at a funeral or memorial service. Charitable donations and other tributes are certainly meaningful, but there is no substitute for flowers during difficult times.',
        },
        {
            question: 'How do I know what charity or charities to donate to?',
            answer: 'If the bereaved would prefer donations to a charity in lieu of flowers, relevant information will typically be found in the obituary or in literature at the funeral parlor. You might also wish to donate to a specific charitable cause on your own; many charities will send a notification to the bereaved of your donation in memory of the deceased.',
        },
        {
            question: 'When it is considered too late to send sympathy flowers?',
            answer: 'It is always more appropriate to acknowledge a loss than to ignore it, especially if the person experiencing the loss is a family member, friend or colleague. It is almost never too late to send a <a class="jss103" href="/Sympathy">sympathy flower arrangement</a> or <a class="jss103" href="/sympathyplants">sympathy plant</a> with a heartfelt message, or a card or letter expressing your condolences.',
        },
        {
            question: 'What are other ways to honor the deceased?',
            answer_content: [
                { description: 'Donate a book in their memory at their local library or yours' },
                { description: 'Donate scholarship money in their name to a school' },
                { description: 'Plant a <a  href="/Sympathy-Creating-A-Memory-Garden">memory garden</a>' },
                { description: 'Create a photo montage' },
            ],
        },
        {
            question: 'Is it appropriate to send flowers to a cemetery?',
            answer: 'Unfortunately cemeteries are not equipped to successfully receive and distribute floral arrangements. We do recommend you send something to the home of a family member or loved one that may be able to complete final delivery to the cemetery.',
        },
    ],

};

export default data;
